import { Pipe, PipeTransform } from '@angular/core';
import { Strings } from '../../common/util/Strings';

@Pipe({ name: 'trim' })
export class TrimPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return value ? Strings.trim(value) : '';
  }
}
